// Mock data for Bharat Enterprises website
// This will be replaced with real backend integration later

export const mockQuoteSubmit = async (formData) => {
  // REAL backend submission - no longer mock
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  
  try {
    const response = await fetch(`${BACKEND_URL}/api/quote-request`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });
    
    const result = await response.json();
    
    if (result.success) {
      return {
        success: true,
        message: result.message,
        quoteId: result.quote_id
      };
    } else {
      throw new Error(result.message || 'Failed to submit quote');
    }
  } catch (error) {
    console.error('Quote submission error:', error);
    return {
      success: false,
      message: error.message || 'Failed to submit quote. Please try again.'
    };
  }
};

export const mockContactSubmit = (formData) => {
  // Simulate contact form submission
  console.log('Contact form submitted:', formData);
  
  // Store in localStorage for demo purposes
  const contacts = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
  const newContact = {
    id: Date.now(),
    ...formData,
    submittedAt: new Date().toISOString()
  };
  contacts.push(newContact);
  localStorage.setItem('contactSubmissions', JSON.stringify(contacts));
  
  return {
    success: true,
    message: 'Thank you for reaching out! Our team will get back to you soon.'
  };
};

export const products = [
  {
    id: 1,
    name: 'Rutile Titanium Dioxide',
    type: 'Premium Grade',
    features: [
      'Superior opacity',
      'High brightness',
      'Excellent durability',
      'Weather resistance'
    ],
    applications: 'Premium paints, coatings, and high-performance plastics',
    imageUrl: 'https://images.pexels.com/photos/7788364/pexels-photo-7788364.jpeg'
  },
  {
    id: 2,
    name: 'Anatase Titanium Dioxide',
    type: 'Cost-Efficient Grade',
    features: [
      'High whiteness',
      'Good dispersion',
      'Excellent coverage',
      'Cost-effective solution'
    ],
    applications: 'Plastics, footwear compounds, PVC, and general industrial uses',
    imageUrl: 'https://images.pexels.com/photos/7230412/pexels-photo-7230412.jpeg'
  }
];

export const industries = [
  {
    id: 1,
    name: 'Paints & Coatings',
    icon: 'Paintbrush',
    description: 'Premium TiO₂ for superior paint formulations',
    imageUrl: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=400'
  },
  {
    id: 2,
    name: 'Plastics & Masterbatch',
    icon: 'Package',
    description: 'High-quality grades for plastic manufacturing',
    imageUrl: 'https://images.unsplash.com/photo-1611079167254-9eac15f60eb7?w=400'
  },
  {
    id: 3,
    name: 'PVC Pipes & Profiles',
    icon: 'Pipe',
    description: 'Specialized TiO₂ for PVC applications',
    imageUrl: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400'
  },
  {
    id: 4,
    name: 'Footwear Compounds',
    icon: 'ShoppingBag',
    description: 'Optimized for footwear manufacturing',
    imageUrl: 'https://images.unsplash.com/photo-1460353581641-37baddab0fa2?w=400'
  },
  {
    id: 5,
    name: 'Artificial Stone',
    icon: 'Gem',
    description: 'Premium whiteness for artificial stone',
    imageUrl: 'https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=400'
  },
  {
    id: 6,
    name: 'Printing Inks',
    icon: 'FileText',
    description: 'High-purity TiO₂ for printing industry',
    imageUrl: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400'
  },
  {
    id: 7,
    name: 'Cosmetics',
    icon: 'Sparkles',
    description: 'Cosmetic-grade TiO₂ for beauty products',
    imageUrl: 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400'
  },
  {
    id: 8,
    name: 'Artificial Leather',
    icon: 'Shirt',
    description: 'Premium grades for synthetic leather production',
    imageUrl: 'https://images.unsplash.com/photo-1491637639811-60e2756cc1c7?w=400'
  },
  {
    id: 9,
    name: 'PVC Window Profiles',
    icon: 'Square',
    description: 'Specialized TiO₂ for window frame manufacturing',
    imageUrl: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=400'
  },
  {
    id: 10,
    name: 'Industrial Applications',
    icon: 'Factory',
    description: 'Diverse industrial manufacturing needs',
    imageUrl: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=400'
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Deep Market Intelligence',
    description: 'We understand commodity cycles, pricing psychology, and industry-specific demand patterns.',
    icon: 'TrendingUp'
  },
  {
    id: 2,
    title: 'Strong Relationship Capital',
    description: 'Long-standing partnerships built on trust, responsiveness, and consistent supply.',
    icon: 'Users'
  },
  {
    id: 3,
    title: 'Reliable Supply Chain',
    description: 'Structured inventory planning ensures minimal disruption to your production cycles.',
    icon: 'Truck'
  },
  {
    id: 4,
    title: 'Balanced Credit Discipline',
    description: '30–45 day structured credit cycles with strong collection control.',
    icon: 'CreditCard'
  },
  {
    id: 5,
    title: 'Scalable & System-Driven',
    description: 'Process-led, scalable distribution organization ensuring speed, accountability, and predictable service.',
    icon: 'Zap'
  }
];
